import React from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
// 引入action

import './friends.css'

import { NetPost, NetGet } from '../../axios'
import { toast } from 'react-toastify'
import { reSetBar } from '../../tool/reSetBar';
import BoardTop from '../board/boardTop';
import LazyImg from '../../components/lazyimg';
import Data from '../board/data'
import { runhtml } from '../../tool/runtime'
import RightBox from '../../components/com_all/rightBox'
class FriendsLink extends React.Component {
    state = {
        data: ""
    }
    componentDidMount() {
        document.title ="友链 ~ |"
        reSetBar()
        this.node.scrollIntoView();
        this.getData()
    }



    getData=()=>{
        NetGet("friendLinks")
        .then((res)=>{
            if(res.code==0){
                this.setState({data:res.data})
            }
        })
    }


    //随机排序
    randomSort=(arr)=>{
        var newList = []
        for(var i=0;i<arr.length;i++){
            var itemlist=arr[i]
            itemlist.data=sortList(itemlist.data)
            newList.push(itemlist)
        }
        return newList

        function sortList(list){
            return  list.sort(function(){
                return Math.random()-0.5;
            });

        }
 
     }


    renderFrindList = (data) => {
        return this.randomSort(data).map((e, i) => {
            return (
                <div key={"links" + i}>
                    <h3 className="link-title" >
                        <span className="fake-title">{e.typetilte}</span>
                    </h3>
                    <ul className="link-items fontSmooth">
                        {
                            e.data.length > 0
                            &&
                            e.data.map((ec, ic) => 
                                <li className="link-item" key={"eclinks" + ic}>
                                    <a className="link-item-inner effect-apollo" href={ec.links} title={`${ec.name}\n${ec.links}\n${ec.detalis}`} target="_blank">
                                        <LazyImg loadimg="https://image.bestzuo.cn/images/20200621224833.gif!getwebp" className="lazyload" src={ec.headimg} />
                                        <span className="sitename">{ec.name}</span>
                                        <div className="linkdes">{ec.detalis}</div>
                                    </a>
                                </li>
                            )
                        }


                    </ul>
                </div>
            )
        })
    }

    render() {
       const { data } = this.state
   
        return (
            <div ref={node => this.node = node} className="allMargintop" style={{ marginBottom: 0 }}>
                <BoardTop loadimg="http://ningcat.com/siteasset/onloading/orange.progress-bar-stripe-loader.svg" bgimg="http://ningcat.com/siteasset/bigimg/friend.jpg" title="友人帐" />



                <section id="content" className=" outer row justify-content-center flex-row-reverse friendlink" style={{  margin: "auto", paddingTop: "3rem" }}>
                    <div className="rightbox">
                        <RightBox className="dark-bg"/>
                    </div>
                    <div className="leftbox ">
                    <article className="links-tips dark-bg">
                        <p>欢迎交换友链 ꉂ(ˊᗜˋ)</p>
                        <br />
                        <p >
                            <h3><span style={{ fontSize: "12pt" }}>请告诉我你的：</span></h3>
                            1、名字<br />
                            2、一句话介绍<br />
                            3、主页地址<br />
                            4、头像</p>
                        <br />

                        <p>
                            <h3><span style={{ fontSize: "12pt" }}>申请友链模板：</span></h3>
                            ★ Name：猫宁 ~ | <br />
                            ★ 头像：https://{window.location.host+"/coverimg/headimg"}<br />
                            ★ 网站链接：{window.location.origin}<br />
                            ★ 网站介绍：两只布偶猫的铲屎官<br />
                            {/* ★ Avatar: <a href="" target="_blank" rel="nofollow">获取嵌入代码</a> */}
                        </p>

                        <div className="links">
                            {
                                data.length>0&&this.renderFrindList(data)
                            }
                        </div>
                    </article>   


                     <div className="dark-bg" style={{marginTop:"1.5rem"}}>
                    <div className="toc-container">
                        <div className="toc"></div>
                    </div>
                    <Data articleid={-1}/>

                    </div>  
                    </div> 
                </section>

                { runhtml }

            </div>
        )
    }
}



export default connect()(FriendsLink)